import React, { Component } from 'react'
import Icon from 'components/icon/icon'

import { Document, Page } from 'react-pdf'

import moment from 'moment'

import { 
    getFileDisplayData,
    hasFailed,
    getFileExtension,
    isMobile
} from 'utils'

class FileDisplay extends Component {
    state = {
        hasRendered: false,
        isProcessingPreview: false,
        hasAbandonedPreview: false
    }

    hasCalledLoadCallback = false
    imgKey = 0

    componentDidMount() {
        const {
            onLoadCallback,
            animateOnRender
        } = this.props

        if (animateOnRender) {
            setTimeout(_ => {
                this.setState({
                    hasRendered: true
                })
            })
        }

        if(onLoadCallback){
            onLoadCallback()
        }
    }

    getUrl = _ => {
        const {
            file,
            isFullSize
        } = this.props

        let urlForDisplayData = (file.thumb_url && !isFullSize) ? file.thumb_url : file.filename
        const displayData = getFileDisplayData(urlForDisplayData)

        let {
            extension,
        } = displayData

        let url = null

        if (file.url) {
            const isGif = file.url.endsWith('.gif')

            if ((!isFullSize && !isGif) || extension == 'pdf' || extension == 'psd' || extension == 'svg') {
                url = file.thumb_url ? file.thumb_url : file.url
            } else {
                url = file.url
            }
        } else if (file.tempUrl) {
            url = file.tempUrl
        }

        return url
    }

    assessLoadCallback = _ => {
        const {
            onLoadCallback
        } = this.props

        if(!this.hasCalledLoadCallback && onLoadCallback){
            this.hasCalledLoadCallback = true
            onLoadCallback()
        }
    }

    render() {
        const {
            file,
            onLoadCallback,
            animateOnRender,
            isFullSize
        } = this.props

        const {
            hasRendered,
            hasAbandonedPreview
        } = this.state

        if(!file){
            return null
        }

        const initialDisplayData = getFileDisplayData(file.filename)
        const displayData = getFileDisplayData(file.thumb_url ? file.thumb_url : file.filename)

        let {
            icon,
            initialTaxonomy,
        } = initialDisplayData

        const {
            taxonomy,
            extension,
        } = displayData

        let url = this.getUrl()

        // if it's given up on the preview, just the original size where possible.
        if(hasAbandonedPreview && initialTaxonomy == 'image'){
            url = file.url
        }

        let className = "file-display"
        let hasError = false

        if (animateOnRender && !hasRendered) {
            className += ' hidden'
        }

        if(hasFailed(file)){
            hasError = true
            icon = 'fe-alert-triangle'
        }

        const isProcessingPreview = !hasError && (this.state.isProcessingPreview ? this.state.isProcessingPreview : file.is_processing_preview)

        if (taxonomy == 'image' && !hasError && !isProcessingPreview) {
            className += ' is-image'
        }

        if (isProcessingPreview) {
            className += ' processing'

            if(taxonomy == 'image'){
                className += ' processing-image'
            }
        }

        // taxonomy is checked against thumbnail data, so a 'document' here means it isn't/won't be thumbnailed
        let showIcon = taxonomy != 'image' || isProcessingPreview || hasAbandonedPreview || hasError

        if(isFullSize && !isMobile()){
            const extension = getFileExtension(file.url)

            if(extension === 'pdf'){
                return (
                    <span className={className}>
                        <Document
                            file={file.url}
                            onLoadSuccess={_ => {}}
                        >
                            <Page 
                                pageNumber={1} 
                                renderTextLayer={false}
                            />
                        </Document>
                    </span>
                )
            }
        }

        return (
            <span className={className}>
                <span className="processing-loader">
                    <Icon name='circle-o-notch' spin={true} />
                </span>
                {url && !isProcessingPreview && taxonomy == 'image' && !hasAbandonedPreview &&
                    <img
                        key={this.imgKey}
                        onLoad={this.assessLoadCallback}
                        src={url}
                    />
                }
                {showIcon ?
                    <Icon name={icon} />
                    : null
                }
            </span>
        )
    }
}

export default FileDisplay;



// WEBPACK FOOTER //
// ./src/components/file/file-display.jsx